import {
  Box,
  Button,
  FormControlLabel,
  FormGroup,
  Radio,
} from '@mui/material';
import * as styles from './CatalogFilterBar.styles';

interface ChoiceOption {
  value: string;
  label: string;
}

interface ChoiceFilterProps {
  value: string | undefined;
  options: ChoiceOption[];
  onChange: (value: string | undefined) => void;
}

export const ChoiceFilter = ({
  value,
  options,
  onChange,
}: ChoiceFilterProps) => (
  <Box sx={styles.popoverContent}>
    <FormGroup sx={{ width: '100%', alignItems: 'flex-start' }}>
      <FormControlLabel
        control={
          <Radio
            checked={!value}
            onChange={() => onChange(undefined)}
            color="primary"
            size="small"
          />
        }
        label="All"
      />
      {options.map((opt) => (
        <FormControlLabel
          key={opt.value}
          control={
            <Radio
              checked={value === opt.value}
              onChange={() => onChange(opt.value)}
              color="primary"
              size="small"
            />
          }
          label={opt.label}
        />
      ))}
    </FormGroup>
    <Button
      variant="text"
      size="small"
      disabled={!value}
      onClick={() => onChange(undefined)}
      sx={styles.clearButton}
    >
      Clear
    </Button>
  </Box>
);
